
        <span>{{contrastText}}</span>
                <span class="k-contrast-validation k-text-success" *ngIf="pass">
                    {{passMessage}}
                    <span class="k-icon k-i-check"></span>
                </span>
                <span class="k-contrast-validation k-text-error" *ngIf="!pass">
                    {{failMessage}}
                <span class="k-icon k-i-close"></span>
        </span>
    